import { intersection } from 'lodash';
import { formatDate, formatTime } from './utils';

/* eslint max-len:0 quote-props:0 */
const strings = {
  de: {
    'Search...': 'Suchen...',
    'Terms of use': 'Nutzungs&shy;bedingungen (EN)',
    Selection: 'Auswahl',
    Done: 'Fertig',
    'Reset selection': 'Auswahl zurücksetzen',
    'Unfortunately, your browser does not support location services.':
      'Dein Browser unterstützt leider keine Ortungsdienste.',
    "We couldn't determine your position": 'Wir konnten deine Position nicht bestimmen.',
    Me: 'Ich',
    Play: 'Play',
    Pause: 'Pause',
    'Play faster': 'Schneller abspielen',
    'Show own position': 'Eigene Position anzeigen',
    'Zoom in': 'Vergrössern',
    'Zoom out': 'Verkleinern',
    'Reset bearing to north': 'Ausrichtung nach Norden zuruecksetzen',
    Fullscreen: 'Vollbild-Modus',
    'Old IE':
      'Racemap isz für moderne Browser-Versionen optimiert. \nBitte verwende einen modernen Browser, wie z.B. Firefox, Chrome, Safari oder Edge.',
    Marker: 'Markierung',
    Offline: 'Offline',
    'Map Type': 'Karte',
    'mapStyle.TERRAIN': 'Gelände',
    'mapStyle.HYBRID': 'Hybrid',
    'mapStyle.SATELLITE': 'Satellit',
    'mapStyle.ROADMAP': 'Straßen',
    'mapStyle.DARK': 'Nacht',
    'Unit Type': 'Einheiten',
    'unitType.METRIC': 'Metrisch',
    'unitType.IMPERIAL': 'Angloamerikanisch',
    'unitType.NAUTICAL': 'Nautisch',
    'pinToShadowTrackMode.NONE': 'Ohne',
    'pinToShadowTrackMode.MAGNETIC': 'Magnetisch',
    'pinToShadowTrackMode.FORCED': 'Immer',
    'Flag Content': 'Fähnchen-Inhalt',
    'flagContent.DEFAULT': 'Standard',
    'flagContent.NAME': 'Name',
    'flagContent.STARTNUMBER': 'Startnummer',
    'flagContent.STARTNUMBER_AND_NAME': 'Startnummer und Name',
    'flagContent.ONE_LETTER_NAMES': 'Abkürzung mit 1 Buchstaben',
    'flagContent.TWO_LETTER_NAMES': 'Abkürzung mit 2 Buchstaben',
    'Show All Flags': 'Alle Fähnchen anzeigen',
    'Time Mode': 'Zeitanzeige',
    'timeMode.RELATIVE': 'Eventzeit',
    'timeMode.ABSOLUTE': 'Tageszeit',
    'Pin to track': 'Starter an die Strecke pinnen',
    'Privacy Policy': 'Datenschutzerklärung',
    'Terms of Use': 'Nutzungsbedingungen',
    'All Events': 'Alle',
    'stats.currentSpeed': 'Aktuelle Geschwindigkeit',
    'stats.distanceFromStart': 'Entfernung und Zeit (hh:mm) vom Start',
    'stats.distanceToFinish': 'Entfernung und Zeit (hh:mm) zum Ziel',
    'stats.accumulatedAscentDescent': 'Akkumulierter Anstieg/Abstieg',
    'stats.gap': 'Abstand zu',
    'info.athletes': 'Sportler',
    'info.website': 'Website',
    'list.CONTEST_GROUP': 'Wettkämpfe',
    'list.STAGE_GROUP': 'Etappen',
    'list.SELECTED': 'Auswahl',
    'list.FILTER': 'Filter',
    'list.N_FILTERED': 'gefiltert',
    'list.N_SELECTED': 'ausgewählt',
    'list.NONE_SELECTED': 'Nichts ausgewählt',
    'list.SHOW_SELECTED': 'Auswahl anzeigen',
    'list.STARTERS': 'Sportler',
    'list.POI_SHORT': 'POI',
    'list.FAVORITE': 'Favoriten',
    'list.POI': 'Points of Interest',
    'list.TRACK': 'Strecken',
    'list.RESET': 'Reset',
    'list.DESELECT': 'Auswahl aufheben',
    'list.SETTINGS': 'Einstellungen',
    'list.DESELECT_TAG': 'Filter zurücksetzen',
    'sort.START_NUMBER': 'Startnummer',
    'sort.NAME': 'Name',
    'sort.OFFSET': 'Fortschritt',
    'sort.RESET': 'Sortierung zurücksetzen',
    'map.followSelected': 'Auswahl zentrieren',
    'Open Leaderboard': 'Ergebnisliste öffnen',
    poi: 'Point of Interest',
    track: 'Strecke',
    'tags.none': '(Ohne)',
    'tags.all': '(Alle)',
    'tags.sex': 'Geschlecht',
    'tags.age': 'Altersklasse',
    'tags.nationality': 'Nationalität',
    'tags.club': 'Verein',
    'tags.status': 'Status',
    'tags.contest': 'Kategorie',
    'seen.now': 'gerade gesehen',
    'seen.lessmin': 'vor <1 min gesehen',
    'seen.min': 'vor {0} min gesehen',
    'seen.hour': 'vor {0} h gesehen',
    'Large Mode': 'Präsentations Modus',
  },
  en: {
    'Search...': 'Search...',
    'Terms of use': 'Terms of use',
    Selection: 'Selection',
    Done: 'Done',
    'Reset selection': 'Reset selection',
    "We couldn't determine your position": "We couldn't determine your position.",
    'Unfortunately, your browser does not support location services.':
      'Unfortunately, your browser does not support location services.',
    Me: 'Me',
    Play: 'Play',
    Pause: 'Pause',
    'Play faster': 'Play faster',
    'Show own position': 'Show own position',
    'Zoom in': 'Zoom in',
    'Zoom out': 'Zoom out',
    'Reset bearing to north': 'Reset bearing to north',
    Fullscreen: 'Fullscreen',
    'Old IE':
      'Racemap is optimized for modern browsers. \nPlease use a modern browser such as Firefox, Chrome, Safari or Edge.',
    Marker: 'Marker',
    Offline: 'Offline',
    'Map Type': 'Map type',
    'mapStyle.TERRAIN': 'Terrain',
    'mapStyle.HYBRID': 'Hybrid',
    'mapStyle.SATELLITE': 'Satellite',
    'mapStyle.ROADMAP': 'Streets',
    'mapStyle.DARK': 'Night',
    'Unit Type': 'Unit type',
    'unitType.METRIC': 'Metric',
    'unitType.IMPERIAL': 'Imperial',
    'unitType.NAUTICAL': 'Nautical',
    'pinToShadowTrackMode.NONE': 'None',
    'pinToShadowTrackMode.MAGNETIC': 'Magnetic',
    'pinToShadowTrackMode.FORCED': 'Always',
    'Show All Flags': 'Show all flags',
    'Flag Content': 'Flag Content',
    'flagContent.DEFAULT': 'Default',
    'flagContent.NAME': 'Name',
    'flagContent.STARTNUMBER': 'Start number',
    'flagContent.STARTNUMBER_AND_NAME': 'Start number and name',
    'flagContent.ONE_LETTER_NAMES': 'Abbreviation with 1 letter',
    'flagContent.TWO_LETTER_NAMES': 'Abbreviation with 2 letters',
    'Time Mode': 'Time display',
    'timeMode.RELATIVE': 'From event start',
    'timeMode.ABSOLUTE': 'Time of day',
    'Pin to track': 'Pin starters to the track',
    'Privacy Policy': 'Privacy Policy',
    'Terms of Use': 'Terms of Use',
    'All Events': 'All',
    'stats.currentSpeed': 'Current Speed',
    'stats.distanceFromStart': 'Distance and Time (hh:mm) from Start',
    'stats.distanceToFinish': 'Distance and Time (hh:mm) to Finish',
    'stats.accumulatedAscentDescent': 'Accumulated Ascent/Descent',
    'stats.gap': 'Gap to',
    'info.athletes': 'athletes',
    'info.website': 'Website',
    'list.SELECTED': 'Selection',
    'list.CONTEST_GROUP': 'Contests',
    'list.STAGE_GROUP': 'Stages',
    'list.FILTER': 'Filter',
    'list.N_FILTERED': 'filtered',
    'list.STARTERS': 'Athletes',
    'list.POI_SHORT': 'POI',
    'list.FAVORITE': 'Favorites',
    'list.POI': 'Points of interest',
    'list.TRACK': 'Tracks',
    'list.RESET': 'Reset',
    'list.DESELECT': 'Clear selection',
    'list.DESELECT_TAG': 'Reset tag filter',
    'list.SETTINGS': 'Settings',
    'list.N_SELECTED': 'selected',
    'list.SHOW_SELECTED': 'Hide unselected',
    'list.NONE_SELECTED': 'None selected',
    'map.followSelected': 'Recenter selection',
    'Open Leaderboard': 'Open Leaderboard',
    poi: 'Point of interest',
    track: 'Track',
    'tags.none': '(None)',
    'tags.all': '(All)',
    'tags.sex': 'Sex',
    'tags.age': 'Age',
    'tags.nationality': 'Nationality',
    'tags.club': 'Club',
    'tags.status': 'Status',
    'tags.contest': 'Contest',
    'sort.START_NUMBER': 'Start number',
    'sort.NAME': 'Name',
    'sort.OFFSET': 'Progress',
    'sort.RESET': 'Reset sorting',
    'seen.now': 'seen now',
    'seen.lessmin': 'seen <1 min ago',
    'seen.min': 'seen {0} min ago',
    'seen.hour': 'seen {0} h ago',
    'Large Mode': 'Large Mode',
  },
  cs: {
    'Search...': 'Hledat...',
    overlay_infobox: 'Zapojte se do online sledování polohy. Stáhněte si aplikaci.',
    'Terms of use': 'Podmínky použítí (EN)',
  },
  es: {
    'Search...': 'Buscar...',
    overlay_infobox: 'Unete al evento. Descarga Racemap.',
    'Terms of use': 'Terminos de Uso (EN)',
  },
  fr: {
    'Search...': 'Recherche...',
    'Terms of use': 'CGU',
    Selection: 'Sélection',
    Done: 'Done',
    'Reset selection': 'Annuler sélection',
    "We couldn't determine your position": 'nous ne pouvons pas déterminer votre position.',
    'Unfortunately, your browser does not support location services.':
      'Malheureusement, votre navigateur ne supporte pas la détermination de votre position.',
    Me: 'Moi',
    Play: 'Lecture',
    Pause: 'Pause',
    'Play faster': 'Jouer plus vite',
    'Show own position': 'Montrer votre position',
    'Zoom in': 'Zoomer',
    'Zoom out': 'Dezoomer',
    'Reset bearing to north': 'Reinitialiser l orientation vers le nord',
    Fullscreen: 'Plein écran',
    'Old IE':
      "Racemap est optimisé pour les navigateurs récents. \nMerci d'utiliser un navigateur moderne comme Firefox, Chrome, Safari ou Edge.",
    Marker: 'Marqueur',
    Offline: 'Offline',
    'Map Type': 'Type de carte',
    'mapStyle.TERRAIN': 'Terrain',
    'mapStyle.HYBRID': 'Hybride',
    'mapStyle.SATELLITE': 'Satellite',
    'mapStyle.ROADMAP': 'Routier',
    'mapStyle.DARK': 'Nuit',
    'Unit Type': 'Unité',
    'unitType.METRIC': 'Métrique',
    'unitType.IMPERIAL': 'Impérial',
    'unitType.NAUTICAL': 'Nautique',
    'pinToShadowTrackMode.NONE': 'Aucun',
    'pinToShadowTrackMode.MAGNETIC': 'Magnétique',
    'pinToShadowTrackMode.FORCED': 'Toujours',
    'Show All Flags': 'Montrer tous les labels',
    'Flag Content': 'Contenu du label',
    'flagContent.DEFAULT': 'Défaut',
    'flagContent.NAME': 'Nom',
    'flagContent.STARTNUMBER': 'Dossard',
    'flagContent.STARTNUMBER_AND_NAME': 'Dossard et nom',
    'Time Mode': 'Affichage du temps',
    'timeMode.RELATIVE': "Depuis l'heure zéro",
    'timeMode.ABSOLUTE': 'Heure du jour',
    'Pin to track': 'Aimanter les labels au tracé',
    'Privacy Policy': 'Politique de confidentialité',
    'Terms of Use': 'CGU',
    'All Events': 'Tous',
    'stats.currentSpeed': 'Vitesse instantannée',
    'stats.distanceFromStart': 'Distance et temps (hh:mm) depuis le départ',
    'stats.distanceToFinish': "Distance et temps (hh:mm) à l'arrivée",
    'stats.accumulatedAscentDescent': 'Dénivelé cumulé',
    'stats.gap': 'Ecart à',
    'info.athletes': 'athlètes',
    'info.website': 'Website',
    'list.SELECTED': 'Sélection',
    'list.CONTEST_GROUP': 'Epreuve',
    'list.STAGE_GROUP': 'Stage',
    'list.FILTER': 'Filtre',
    'list.N_FILTERED': 'filté',
    'list.STARTERS': 'Athlètes',
    'list.FAVORITE': 'Favorites',
    'list.POI_SHORT': 'POI',
    'list.POI': "Point d'intéret",
    'list.TRACK': 'Traces',
    'list.RESET': 'Reset',
    'list.DESELECT': 'Effacer sélection',
    'list.DESELECT_TAG': 'Reinitialiser filtre tag',
    'list.SETTINGS': 'Paramètres',
    'list.N_SELECTED': 'Sélectionné',
    'list.SHOW_SELECTED': 'Montrer sélection',
    'list.NONE_SELECTED': 'Aucun sélectionné',
    'map.followSelected': 'Recentrer sur la sélection',
    'Open Leaderboard': 'Ouvrir Leaderboard',
    poi: "Point d'intérêt",
    track: 'Trace',
    'tags.none': '(Aucun)',
    'tags.all': '(Tous)',
    'tags.sex': 'Sexe',
    'tags.age': 'Age',
    'tags.nationality': 'Nationalité',
    'tags.club': 'Club',
    'tags.status': 'Statut',
    'tags.contest': 'Epreuve',
    'sort.STARTNUMBER': 'Dossard',
    'sort.NAME': 'Nom',
    'sort.OFFSET': 'Progrès',
    'sort.RESET': 'Reinitialiser tri',
    'seen.now': 'Vu maintenant',
    'seen.lessmin': 'Vu il y a <1 min',
    'seen.min': 'Vu il y a {0} min',
    'seen.hour': 'Vu il y a {0} h',
    'Large Mode': 'Grand mode',
  },
};

const defaultLang = 'en';

function getLanguage(): string {
  const availableLanguages = Object.keys(strings);
  // Language in Querystring
  const match = window.location.pathname.match(/^\/(\w\w)\//);
  if (match) {
    const forcedLanguage = match[1];
    if (availableLanguages.includes(forcedLanguage)) {
      return forcedLanguage;
    }
    return defaultLang;
  }

  // Navigator language
  let navigatorLanguages = [];
  if (navigator.languages) {
    navigatorLanguages = navigator.languages.map((l) => l.substring(0, 2));
  } else if (navigator.language) {
    navigatorLanguages = [navigator.language.substring(0, 2)];
  }

  const language = intersection(navigatorLanguages, availableLanguages)[0];

  if (language == null) {
    return defaultLang;
  }
  return language;
}

export function t(string: string, fallback?: string): string {
  const language = getLanguage();
  const translation = strings[language][string];
  if (translation) {
    return translation;
  }
  const defaultTranslation = strings[defaultLang][string];
  if (defaultTranslation) {
    return defaultTranslation;
  }
  if (fallback != null) {
    return fallback;
  }
  // eslint-disable-next-line no-console
  console.log('Missing translation', string, language);
  return string;
}

export function tt(string: string, ...args: Array<string>): string {
  const language = getLanguage();
  const translation = strings[language][string];
  if (translation) {
    return translation.replace(/{(\d+)}/g, (_, index) => args[index]);
  }
  const defaultTranslation = strings[defaultLang][string];
  if (defaultTranslation) {
    return defaultTranslation.replace(/{(\d+)}/g, (_, index) => args[index]);
  }
  // eslint-disable-next-line no-console
  console.log('Missing translation', string, language);
  return string;
}

export function formatDateTimeT(date: number): string {
  const language = getLanguage();
  if (window.Intl == null) {
    return `${formatDate(date)} ${formatTime(date)}`;
  }
  return new window.Intl.DateTimeFormat(language, {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
